import * as d3 from "d3";
import { useState, useEffect } from "react";

const dateParse = d3.timeParse("%d-%m-%Y");

export const useHedayahData = (urls) => {
  const [countries, setCountries] = useState([]);
  const [labelsData, setLabelsData] = useState({});
  const [casesData, setCasesData] = useState([]);
  const [incidentData, setIncidentData] = useState([]);
  const [stringencyData, setStringencyData] = useState([]);
  const [annotationData, setAnnotationData] = useState([]);
  const [loading, setLoading] = useState(true);

  const urlArr = [
    urls.casesUrl,
    urls.incidentsUrl,
    urls.labelsUrl,
    urls.annotUrl,
    urls.stringencyUrl
  ];

  useEffect(() => {
    if(!loading) return;

    const promises = [];

    urlArr.forEach((url) => promises.push(url ? d3.csv(url) : null));

    Promise.all(promises).then((data) => {

      var casesDataRaw = data[0];
      var incidentDataRaw = data[1];
      var labelsDataRaw = data[2];
      var annotationDataRaw = data[3];
      var stringencyDataRaw = data[4];

      var countries = [];

      for (var i = 1; i < casesDataRaw.columns.length; i++) {
        countries.push(casesDataRaw.columns[i]);
      }

      if (!incidentDataRaw) incidentDataRaw = [];
      incidentDataRaw.forEach((item) => {
        var retval = {};
        retval.date = dateParse(item.Date);
        countries.forEach((country) => {
          retval[country] = +item[country];
        });
        incidentData.push(retval);
      });

      const labels = labelsDataRaw.reduce(function (map, obj) {
        map[obj.key] = obj.value;
        return map;
      }, {});

      casesDataRaw.forEach((item) => {
        var retval = {};
        retval.date = dateParse(item.Date);
        countries.forEach((country) => {
          retval[country] = +item[country];
        });
        casesData.push(retval);
      });

      annotationDataRaw.forEach((item) => {
        var retval = {};
        retval.date = dateParse(item.Date);
        retval.annotation = item.Annotation;
        annotationData.push(retval);
      });

      if (!stringencyDataRaw) stringencyDataRaw = [];
      stringencyDataRaw.forEach((item) => {
        var retval = {};
        retval.date = dateParse(item.Date);
        countries.forEach((country) => {
          retval[country] = item[country] ? +item[country] : null;
        });
        stringencyData.push(retval);
      });

      setStringencyData(stringencyData);
      setCountries(countries);
      setLabelsData(labels);
      setCasesData(casesData);
      setAnnotationData(annotationData);
      setIncidentData(incidentData);
      setLoading(false);
    });

    return () => undefined;
  }, []);

  return {
    casesData,
    incidentData,
    stringencyData,
    annotationData,
    countries,
    labelsData,
    loading,
  };
};
